<template>
  <c-form-item :formItems="formItems" ref="cFormItem" />
</template>

<script>
  import CFormItem from '../CForm/CFormItem';

  export default {
    components: {
      CFormItem
    },
    props: {
      formItems: Array
    },
  }
</script>

<style>
</style>
